<template>
	<div class="ImBox">
		<div class="ImBox-title">
			<div class="ImBox-title-l">
				<img class="ImBox-head" src="../assets/img/kao1.png" />
				<span>XX客服</span>
			</div>
			<div class="ImBox-title-r">
				<img class="icn1" src="../assets/img/micn1.png" />
				<img class="icn2" src="../assets/img/micn2.png" />
				<img class="icn3" @click="close" src="../assets/img/micn3.png" />
			</div>
		</div>
		<div class="ImBox-msg-list">
			<div class="ImBox-msg-more">点击加载历史记录</div>
			<div class="ImBox-msg-time">今天23:01</div>
			<div class="ImBox-msg-service">
				<div class="ImBox-msg-name">XX客服</div>
				<div class="ImBox-msg-content">您好。我是机器人小助手。</div>
			</div>
			<div class="ImBox-msg-service2">
				<div class="ImBox-msg-god">我是机器人小助手</div>
			</div>
		</div>
		<div class="ImBox-bar">
			<div class="ImBox-bar-top">
				<img src="../assets/img/micn4.png" />
				<img src="../assets/img/micn5.png" />
				<img src="../assets/img/micn6.png" />
			</div>
			<div class="ImBox-bar-bottom">
				<Input v-model="textarea" type="textarea" placeholder="请输入" />
				<div class="ImBox-bar-btn">发送</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "ImBox",
		data() {
			return {
				textarea: ''
			};
		},
		created() {},
		mounted() {},
		computed: {},
		methods: {
			close() {
				this.$emit('close')
			}
		}
	};
</script>

<style lang="scss">
	.ImBox {
		width: 570px;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
		border-color: #eee;
		&-title {
			height: 70px;
			background: #31AF58;
			display: flex;
			padding: 15px 12px 12px 20px;
			justify-content: space-between;
			align-items: center;
			&-l {
				display: flex;
				align-items: center;
				span {
					color: #FFFFFF;
					font-size: 16px;
					margin-left: 10px;
				}
			}
			&-r {
				img {
					margin-right: 10px;
					cursor: pointer;
				}
			}
		}
		&-head {
			width: 40px;
			height: 40px;
			border-radius: 50%;
		}
		&-msg {
			&-list {
				background: #FAFAFA;
				height: 450px;
				overflow-y: auto;
				padding: 15px 20px;
			}
			&-more {
				text-align: center;
				color: #BBBBBB;
				font-size: 13px;
				cursor: pointer;
			}
			&-time {
				text-align: center;
				font-size: 12px;
				color: #999999;
			}
			&-name {
				font-size: 14px;
				color: #999999;
			}
			&-content {
				background: #EEEEEE;
				padding: 15px 26px 42px;
				color: #333;
				font-size: 14px;
				display: inline-block;
				border-radius: 5px;
			}
			&-god {
				background: #31AF58;
				padding: 20px 30px;
				color: #fff;
				font-size: 14px;
				display: inline-block;
				border-radius: 5px;
			}
			&-service {
				margin-bottom: 28px;
			}
			&-service2 {
				text-align: right;
			}
		}
		&-bar {
			background: #fff;
			height: 120px;
			padding: 10px 14px 14px;
			&-top {
				img {
					cursor: pointer;
				}
			}
			&-bottom {
				display: flex;
				align-items: flex-end;
			}
			&-btn {
				width: 80px;
				height: 34px;
				background: rgba(238, 238, 238, 1);
				border-radius: 5px;
				color: #fff;
				font-size: 14px;
				text-align: center;
				line-height: 34px;
				cursor: pointer;
				margin-left: 20px;
			}
			textarea.ivu-input {
				border: none;
				resize: none;
			}
		}
	}
	
</style>